// A colour made see-through, for washes and borders: tint("#2f6f6b", "1A") -> "#2f6f6b1A". A theme colour such as
// "var(--brand)" can't take a hex suffix, so it is mixed with transparent instead (same strength).
export function tint(colour, alphaHex) {
  if (typeof colour !== "string" || !colour) return colour;
  if (colour.startsWith("#")) return `${colour}${alphaHex}`;
  const pct = Math.round((parseInt(alphaHex, 16) / 255) * 100);
  return `color-mix(in srgb, ${colour} ${pct}%, transparent)`;
}
